var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import apiClient from '@utils/api-client';
// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------
const BASE_URL = '/api/v1/ai/chat_sessions';
// ---------------------------------------------------------------------------
// Mapper: Rails shape → frontend Conversation
// ---------------------------------------------------------------------------
function mapSessionToConversation(session) {
    var _a;
    return {
        id: session.id,
        sessionId: session.sessionId,
        title: session.title || 'Untitled',
        lastAgent: (_a = session.lastAgent) !== null && _a !== void 0 ? _a : null,
        messageCount: session.messageCount,
        lastActivityAt: session.lastActivityAt,
        createdAt: session.createdAt
    };
}
export function getChatSessions(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const queryParams = {};
            if (options === null || options === void 0 ? void 0 : options.page)
                queryParams.page = options.page;
            if (options === null || options === void 0 ? void 0 : options.perPage)
                queryParams.per_page = options.perPage;
            const response = yield apiClient.get(BASE_URL, { params: queryParams });
            const { chatSessions, meta } = response.data;
            const conversations = chatSessions.map(mapSessionToConversation);
            return {
                conversations,
                meta
            };
        }
        catch (error) {
            console.error('[chatSessionsApi] Error fetching chat sessions:', error);
            throw error;
        }
    });
}
// ---------------------------------------------------------------------------
// GET /api/v1/ai/chat_sessions/:id
// ---------------------------------------------------------------------------
export function getChatSession(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.get(`${BASE_URL}/${id}`);
            return mapSessionToConversation(response.data.chatSession);
        }
        catch (error) {
            console.error('[chatSessionsApi] Error fetching chat session:', error);
            throw error;
        }
    });
}
// ---------------------------------------------------------------------------
// GET /api/v1/ai/chat_sessions/:session_id (by UUID)
// ---------------------------------------------------------------------------
export function getChatSessionBySessionId(sessionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(`${BASE_URL}/${sessionId}`);
        return mapSessionToConversation(response.data.chatSession);
    });
}
export function createChatSession(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const body = {};
            if (options === null || options === void 0 ? void 0 : options.firstMessage)
                body.first_message = options.firstMessage;
            if (options === null || options === void 0 ? void 0 : options.sessionId)
                body.session_id = options.sessionId;
            const response = yield apiClient.post(BASE_URL, body);
            return mapSessionToConversation(response.data.chatSession);
        }
        catch (error) {
            console.error('[chatSessionsApi] Error creating chat session:', error);
            throw error;
        }
    });
}
// ---------------------------------------------------------------------------
// DELETE /api/v1/ai/chat_sessions/:id
// ---------------------------------------------------------------------------
export function deleteChatSession(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield apiClient.delete(`${BASE_URL}/${id}`);
        }
        catch (error) {
            console.error('[chatSessionsApi] Error deleting chat session:', error);
            throw error;
        }
    });
}
